module.exports = __webpack_public_path__ + "media/theme/icon__edit--active-a4b8d351.svg";